require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-fourdrinier-house-tambour-townhouses-update.json") })
        }
      }, "path---news-fourdrinier-house-tambour-townhouses-update");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-fourdrinier-house-tambour-townhouses-update!./.cache/json/news-fourdrinier-house-tambour-townhouses-update.json
// module id = 810
// module chunks = 231608221292675